import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { useSelectDropdownItemStyles } from 'components/UI/V2/SelectDropdown/Item/SelectDropdownItem.styles';
import React from 'react';
import { Link } from 'react-router-dom';

interface SelectDropdownItemProps {
    label: string;

    href?: string;

    leftIcon?: IconProp;
    rightIcon?: IconProp;

    leftElement?: React.ReactNode;
    rightElement?: React.ReactNode;

    className?: string;

    onClick?: () => void;
}

export const SelectDropdownItem: React.FC<SelectDropdownItemProps> = props => {
    const classes = useSelectDropdownItemStyles();

    const Component = props.href ? Link : 'div';

    return (
        <Component
            to={props.href ?? ''}
            className={clsx(classes.root, props.className, {
                [classes.clickable]: !!props.onClick
            })}
            onClick={props.onClick}
        >
            {props.leftElement}

            {props.leftIcon && <FontAwesomeIcon icon={props.leftIcon} />}

            {props.label}

            {props.rightIcon && <FontAwesomeIcon icon={props.rightIcon} />}

            {props.rightElement}
        </Component>
    );
};
